import { useEffect } from 'react';
import { useGetSessionQuery } from '../api/apiSlice';

export function useSilentAuthGuard() {
  const { data, error, isLoading, refetch } = useGetSessionQuery();

  useEffect(() => {
    if (isLoading) return;

    // Unauthenticated
    if (data?.authenticated === false) {
      const returnTo = window.location.pathname + window.location.search;
      window.location.href = `/auth/silent-login?returnTo=${encodeURIComponent(returnTo)}`;
    }

    // Optional: handle permanent failure after redirect
    if (error) {
      console.warn("Auth check failed", error);
    }
  }, [data, isLoading, error]);
}